import JSZip from "jszip";
import FileSaver from "file-saver";
import { FileData } from "../core/types";

// TODO: add function for writing/reading zip file from many file items with paths.

export const createZipFile = (zipFileName: string, files: FileData[]): void => {
  const zip = new JSZip();
  files.forEach((file) => zip.file(file.fileName, file.content));
  zip.generateAsync({ type: "blob" })
    .then((bin) => {
      //console.log(bin);
      FileSaver.saveAs(bin, zipFileName);
    });
}

export const createZipDataBase64 = async (zipFileName: string, files: FileData[]) => {
  const zip = new JSZip();
  files.forEach((file) => {
    if (file.content && file.content.startsWith('data:') && file.content.includes(';base64,')) {
      const base64Data = file.content.split(',')[1];
      zip.file(file.fileName, base64Data, { base64: true });
    } else {
      zip.file(file.fileName, file.content);
    }
  });
  // generate dataUrl base64 from JSZip file
  const data = await zip.generateAsync({ type: "base64" })
  return "data:application/zip;base64," + data;
}

export const readZipFile = (bin: string): void => {
  const zip = new JSZip();
  zip.loadAsync(bin).then((zip) => {
    zip.forEach((path, file) => {
      file.async("text").then((content) => console.log(content));
    });
  });
}

export const compressAsBase64 = (stringContent: string, callback: (data: string) => void): void => {
  const zip = new JSZip();
  zip.file("content", stringContent);
  zip.generateAsync({ type: "base64" })
    .then((data) => {
      //console.log(data);
      if (callback !== undefined) {
        callback(data);
      }
    });
}

export const compressAsBase64Async = async (stringContent: string): Promise<string> => {
  const zip = new JSZip();
  zip.file("content", stringContent);
  const data = await zip.generateAsync({ type: "base64" });
  return data;
}

export const decompressBase64 = (data: string, callback: (data: string) => void): void => {
  const zip = new JSZip();
  zip.loadAsync(data, { base64: true }).then((zip) => {
    zip.forEach((path, file) => {
      file.async("text").then((content) => callback(content));
    });
  });
}

export const decompressBase64Async = async (data: string, callback: (data: string) => void) => {
  const zip = new JSZip();
  const zipContent = await zip.loadAsync(data, { base64: true });

  // Array für die Verfolgung der ausstehenden Promises
  const promises: Promise<void>[] = [];

  zipContent.forEach(async (path, file) => {
    const content = await file.async("text");
    const promise = new Promise<void>((resolve) => {
      callback(content);
      resolve();
    });
    promises.push(promise);
  });

  // Warte, bis alle Promises abgeschlossen sind
  await Promise.all(promises);
};
